"use strict";
var Observable_1 = require("../../Observable");
var window_1 = require("../../operator/window");
Observable_1.Observable.prototype.window = window_1.window;
//# sourceMappingURL=window.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/window.js
 ** module id = 433
 ** module chunks = 1
 **/